import { createSelector } from 'reselect';

const cmsSelector = ({ cms }) => cms || {};

const i18nSelector = createSelector(cmsSelector, (i18n) => i18n || {});
export { i18nSelector };
